export function cloneCanvas(
  sourceCanvas: HTMLCanvasElement,
  clear = true,
): [CanvasRenderingContext2D, HTMLCanvasElement] | never {
  const isSourceCanvasValid = sourceCanvas instanceof HTMLCanvasElement;

  if (!isSourceCanvasValid) {
    throw new Error("Source canvas is not a valid HTMLCanvasElement");
  }

  const virtualCanvas = document.createElement("canvas");
  const virtualCtx = virtualCanvas.getContext("2d");

  if (virtualCtx === null) {
    throw new Error("Could not get 2d context from virtual canvas");
  }

  const { width, height } = sourceCanvas;
  virtualCanvas.width = width;
  virtualCanvas.height = height;

  if (clear) {
    virtualCtx.clearRect(0, 0, width, height);
  }

  return [virtualCtx, virtualCanvas];
}
